import React from "react";
import style from "css/workspace.module.css";
import Detailcommon from "./detailcommon";
import Questions from "components/app/questions";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";

function Conference() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const BodyHeader = (
    <div className={style.bodyTitle}>
      <p>
        복잡한 <font>회의실 예약을 간단</font>하게 해결하고
      </p>
      <p>
        <font>실시간 관리로</font>모든 회의 공간을 효율적으로 운영하세요요
      </p>
    </div>
  );
  const BodyInfo = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          <font>
            회의실 예약부터 다가오는 회의 일정을 알려주는 타임라인까지 회의
            일정을 관리해주고
          </font>
          <font>참여할 수 있는 사이트 입니다.</font>
        </div>
      ),
      title: "회의실 예약 플랫폼\n ( Meeting room Reservation )",
      img: "img/smartspace/conferenceBody1.png",
      img_m: "img/smartspace/conferenceBody1_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          <font>
            회의실 예약 완료와 동시에 예약된 회의실의 Wall Pad에 일정이 동기화
            됩니다.
          </font>
          <font>
            회의실 Wall Pad의 “Reserve” 버튼을 클릭하여 회의실 현장 예약도
            가능합니다.
          </font>
        </div>
      ),
      title: "회의실 입장 및 현황 Wall Pad",
      img: "img/smartspace/conferenceBody2.png",
      img_m: "img/smartspace/conferenceBody2_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          <font>
            노트북 or PC에 무선 컨퍼런싱 단말 클릭쉐어 버튼을 연결하면 회의 준비
            완료 !
          </font>
          <font>회의 중간에 발표자를 쉽게 변경할 수 있으며,</font>
          <font>콘텐츠가 저장된 어떤 디바이스와도 연결 가능합니다.</font>
        </div>
      ),
      title: "회의실 이용 ( Wireless 환경 )",
      img: "img/smartspace/conferenceBody3.png",
      img_m: "img/smartspace/conferenceBody3_m.png",
    },
  ];
  const BodyFooterTitle = (
    <div className={style.bodyFooterTitle}>
      <p>쉽고 빠른 예약 · 실시간 공간 관리{"\n"} · 최적의 업무 환경을 위한</p>
      <p>
        리브테크놀로지의<font> 스마트 회의실 예약 시스템</font>
      </p>
    </div>
  );
  const BodyFooter = [
    {
      id: 1,
      txt: "사내의 회의실 현황을 한눈에 볼 수 있어 빈 회의실과 사용중인 회의실 이용 현황을 바로 파악할 수 있습니다. 빈 회의실에 즉시예약과 사용이 가능하며 회의 정보를 볼 수 있어 업무 효율이 향상됩니다.",
      title: "회의실 예약 편의 및 효율 증대",
    },
    {
      id: 2,
      txt: "플랫폼은 각자의 PC에서, Wall Pad는 한눈에 회의실 사용여부를 알 수 있기 때문에 시스템을 이용하는데 편리하게 구성되어 있습니다.",
      title: "직관적 구성",
    },
    {
      id: 3,
      txt: "방을 감지하는 기능이 내장되어 있어, 회의실에 사람이 들어오면 자동으로 기능이 켜지고 사람이 감지 되지 않으면 에너지 절약을 위해 절전 모드로 전환됩니다. 사람이 직접 키고 끄는 번거로움이 없습니다.",
      title: "스마트 인지 시스템",
    },
  ];
  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      회의실 예약 시스템 <font>구성 환경</font>
    </div>
  );
  const Compose = [
    {
      id: 1,
      img: "img/smartspace/composeImg1.png",
      title: "스마트 워크 플랫폼 all Place",
      txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
      onClick: () => showDrawer("allplace"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_pad.png",
      title: "회의실 현황 및 컨트롤러 neat.pad",
      txt: "회의실 앞에 설치된 Wall Pad는 회의실 예약 및 상태를 실시간으로 확인할 수 있는 디바이스입니다. 사용자는 Wall Pad를 통해 회의실의 예약 현황을 확인하고, 간편하게 회의실 예약, 시작 및 종료를 관리할 수 있어 효율적인 공간 활용이 가능합니다.",
      onClick: () => showDrawer("pad"),
    },
    {
      id: 3,
      img: "img/device/neat/swiper_clickshare.png",
      title: "Wireless환경 : 무선 컨퍼런싱",
      txt: "ClickShare는 회의실에서 별도의 케이블 없이 무선으로 화면을 공유할 수 있는 솔루션입니다. 버튼 클릭 한 번으로 회의실 디스플레이에 콘텐츠를 손쉽게 전송하고, 빠르고 원활한 협업 환경을 제공합니다.",
      onClick: () => showDrawer("clickshare"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };

  return (
    <>
      <SEOMeta
        title="회의실 예약 시스템, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 회의실 예약 시스템"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 회의실 예약 시스템"
      />
      <NeatPopup />
      <div className={style.wrapper}>
        <div
          className={style.commonHeader}
          style={isMobile || isTablet ? { paddingBottom: 0 } : {}}
        >
          <div className={style.CommonHeaderTxt}>
            <p>Meeting Room Reservation System</p>
            <p>회의실 예약 시스템</p>
            {!isMobile && !isTablet ? (
              <p>
                <font>
                  회의실 예약 시스템은 PC · 모바일 등으로 쉽고 편리하게 회의실을
                  예약하고
                </font>
                <font>
                  동시에 예약 회의실 Wall Pad에 예약 일정이 동기화 됩니다.
                </font>
                <font>
                  회의실 Wall Pad의 Reserve 버튼을 클릭하여 회의실 현장 예약도
                  가능합니다.
                </font>
              </p>
            ) : (
              <p>
                <font>
                  회의실 예약 시스템은 PC · 모바일 등으로{"\n"}쉽고 편리하게
                  회의실을 예약하고 동시에{"\n"}예약 회의실 Wall Pad에 예약
                  일정이 동기화 됩니다.{"\n"}회의실 Wall Pad의 Reserve 버튼을
                  클릭하여
                  {"\n"}회의실 현장 예약도 가능합니다.
                </font>
              </p>
            )}
          </div>
          <img
            alt=""
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/conferenceHeader.png`
                : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/conferenceHeader_m.png`
            }
          />
        </div>

        <Detailcommon
          bodyHeader={BodyHeader}
          bodyInfo={BodyInfo}
          bodyFooter={BodyFooter}
          compose={Compose}
          bodyFooterTitle={BodyFooterTitle}
          composeHeader={ComposeHeader}
        />
        <Questions />
      </div>
    </>
  );
}

export default Conference;
